import {
  SCHEMA_RESPONSE,
  SCHEMA_AUTOSUGGEST_REQUEST_COMPLETED,
  REMOVE_ENTITY_FROM_AUTOLOADER_LIST,
  ADD_TO_FORM_ARRAY, REMOVE_FROM_FORM_ARRAY, ARRAY_FORM_EDIT
} from '../actions/schemaActions';
import {
  SCHEMA_REQUEST,
  SCHEMA_REQUEST_COMPLETED,
  AUTOLOADING_FORM_EDITED,
  GIVE_INITIAL_DATA,
} from "../actions/schemaActions";
import { LOG_OUT_USER } from "../actions/globalActions";
import initialState from "../state/initialState";
import produce from "immer";

function logOutUserReduction() {
  return initialState.autoLoaders;
}

function autoloadingFormEditedReduction(state, action) {
  return produce(state, (draft) => {
    const { autoLoaderId, property, newValue } = action;
    const loader = state.loaders[autoLoaderId];
    const propertyNameWithoutId = property.slice(0, -2);

    if (
      property.endsWith("Id") &&
      newValue === null &&
      loader &&
      loader[propertyNameWithoutId] &&
      loader[propertyNameWithoutId] !== null &&
      typeof loader[propertyNameWithoutId] === "object"
    ) {
      if(!state.loaders[autoLoaderId]) {
        draft.loaders[autoLoaderId] = { [propertyNameWithoutId]: null };
      } else {
        draft.loaders[autoLoaderId][propertyNameWithoutId] = null;
      }
    }
  
    if(!state.loaders[autoLoaderId]) {
      draft.loaders[autoLoaderId] = { [property]: newValue };
    } else {
      draft.loaders[autoLoaderId][property] = newValue;
    }
  });
}

function giveInitialDataReduction(state, action) {
  return produce(state, (draft) => {
    const { autoLoaderId, data } = action;
    draft.loaders[autoLoaderId] = data;
  });
}

function removeEntityFromAutoLoaderList(state, action) {
  return produce(state, (draft) => {
    const { entityId, autoLoaderId } = action;
    const loader = draft.loaders[autoLoaderId];

    if (loader && Array.isArray(loader)) {
      const index = loader.findIndex((l) => l.id === entityId);
      loader.splice(index, 1);
    }
  });
}

function userListResponseReduction(state, action) {
  return produce(state, (draft) => {
    const { response, id: autoLoaderId } = action;
    draft.loaders = draft.loaders ?? {};
    if(draft.loaders[autoLoaderId]) {
      if(Array.isArray(response)) {
        draft.loaders[autoLoaderId] = response;
      } else {
        const previousData = draft.loaders[autoLoaderId];
        draft.loaders[autoLoaderId] = {
          ...previousData,
          ...response
        };
      }
    } else {
      draft.loaders[autoLoaderId] = response;
    }
  });
}

function schemaAutoSuggestRequestCompleted(state, action) {
  return produce(state, (draft) => {
    const { id: autoLoaderId, property, response } = action;
    draft.suggesters = draft.suggesters ?? {};
    draft.suggesters[autoLoaderId] = draft.suggesters[autoLoaderId] ?? {};
    draft.suggesters[autoLoaderId][property] = response;
  });
}

function schemaRequestReduction(state, action) {
  return produce(state, (draft) => {
    const { id: autoLoaderId } = action;
    draft.loadingList = draft.loadingList ?? {};
    draft.loadingList[autoLoaderId] = action.inProgress;
  });
}

function removeFromFormArray(state, action) {
  return produce(state, (draft) => {
    const {autoLoaderId, index} = action;
    draft.loaders = draft.loaders ?? {};
    if(draft.loaders[autoLoaderId]) {
      draft.loaders[autoLoaderId].splice(index, 1);
    }
  });
}

function addToFormArray(state, action) {
  return produce(state, (draft) => {
    const {autoLoaderId, newItem} = action;
    draft.loaders = draft.loaders ?? {};
    if(draft.loaders[autoLoaderId]) {
      draft.loaders[autoLoaderId].push(newItem);
    } else {
      draft.loaders[autoLoaderId] = [newItem];
    }
  });
}

function arrayFormEdit(state, action) {
  return produce(state, (draft) => {
    const {autoLoaderId, index, property, value} = action;
    draft.loaders = draft.loaders ?? {};
    if(draft.loaders[autoLoaderId]) {
      draft.loaders[autoLoaderId][index][property] = value;
    }
  })
}

export default function autoLoaders(state = {}, action) {
  const mapping = {
    [SCHEMA_RESPONSE]: userListResponseReduction,
    [SCHEMA_AUTOSUGGEST_REQUEST_COMPLETED]: schemaAutoSuggestRequestCompleted,
    [SCHEMA_REQUEST]: schemaRequestReduction,
    [SCHEMA_REQUEST_COMPLETED]: schemaRequestReduction,
    [LOG_OUT_USER]: logOutUserReduction,
    [REMOVE_ENTITY_FROM_AUTOLOADER_LIST]: removeEntityFromAutoLoaderList,
    [AUTOLOADING_FORM_EDITED]: autoloadingFormEditedReduction,
    [GIVE_INITIAL_DATA]: giveInitialDataReduction,
    [ADD_TO_FORM_ARRAY]: addToFormArray,
    [REMOVE_FROM_FORM_ARRAY]: removeFromFormArray,
    [ARRAY_FORM_EDIT]: arrayFormEdit
  };

  return mapping[action.type] ? mapping[action.type](state, action) : state;
}
